import useDisplayName from "ai-management/token-usage/hooks/useDisplayName";
import useTokenUsage from "ai-management/token-usage/hooks/useTokenUsage";
import { distinctValues } from "ai-management/token-usage/usageSummary";
const toOptions = (values, selected, labelFor) => [.../* @__PURE__ */ new Set([...values, ...selected])].map((value) => ({ value, label: labelFor(value), hasUsage: values.includes(value) })).sort((a, b) => a.label.localeCompare(b.label));
const useUsageFilterOptions = ({
  timerange,
  feature_id: featureIds,
  provider: providers,
  model: models
}) => {
  var _a;
  const displayName = useDisplayName();
  const { data: usage, isLoading } = useTokenUsage({ timerange, feature_id: [], provider: [], model: [] });
  const rows = (_a = usage == null ? void 0 : usage.rows) != null ? _a : [];
  return {
    data: {
      features: toOptions(distinctValues(rows, "feature_id"), featureIds, (value) => displayName({ feature_id: value })),
      providers: toOptions(distinctValues(rows, "provider"), providers, (value) => displayName({ provider: value })),
      models: toOptions(distinctValues(rows, "model"), models, (value) => displayName({ model: value }))
    },
    isLoading
  };
};
export default useUsageFilterOptions;
